import { ProgramTypeVariants, WarehouseChannelBadgeStatus, ProductFulfillmentCategories, DeliveryStatus } from "../../constants.js";
import { getProductNavigationUrl } from "../../productService/lib.js";
import { isBD, isBC } from "../../../utils/businessType.lib.js";
import { hasMembershipId } from "../../../utils/index.js";
import { getProductFullfillmentTexts } from "../../../components/Product/PriceTooltip/lib.js";
import { TRAVEL_DESTINATION, PROGRAM_TYPES_PRICE, PROGRAM_TYPES_PRICE_WAREHOUSE, INVALID_LOCATIONS, PRODUCT_CLASS_TYPES } from "./constants.js";
const itemIsMemberOnlyPriceInCartOnly = (item) => {
  const { item_member_only, item_product_price_in_cart_only } = item || {};
  return Boolean(item_member_only) && item_product_price_in_cart_only === "1";
};
const getPillBadges = (item_pill_attributes, pillBadgeConfig, domainUrl, keyword) => {
  if (!item_pill_attributes || !item_pill_attributes.length) return null;
  const { defaultColor, colorMap, catalogSearchUrl } = pillBadgeConfig || {};
  return item_pill_attributes == null ? void 0 : item_pill_attributes.map((item) => {
    const pillValue = item.split("|")[1];
    let sanitizedPillValue = pillValue.replaceAll(
      "^[^a-zA-Z0-9]+|[^a-zA-Z0-9]+$",
      ""
    );
    sanitizedPillValue = sanitizedPillValue.replaceAll("[/\\\\]", "-");
    sanitizedPillValue = sanitizedPillValue.replaceAll("[^\\w\\s\\-]", "");
    sanitizedPillValue = sanitizedPillValue.replaceAll("[\\s\\-]+", "-");
    sanitizedPillValue = sanitizedPillValue.toLowerCase();
    const searchParams = encodeURIComponent(sanitizedPillValue);
    const pillBadgeLinkUrl = pillBadgeConfig.isDomainInclusionDisabledByKeyword && !keyword ? `?keyword=${searchParams}` : `${domainUrl}${catalogSearchUrl}${searchParams}`;
    const tranformedColorKey = (pillValue == null ? void 0 : pillValue.replace(/[\s]|[&/\\#,+()$~%.:*?<>{}]/g, "_")) || "";
    const color = (colorMap == null ? void 0 : colorMap[tranformedColorKey]) || defaultColor;
    return {
      color,
      link: pillBadgeLinkUrl.toString(),
      text: pillValue
    };
  });
};
const getReplacementItemNumber = (item) => {
  const { item_location_replacementType_s, item_location_replacedItem_s } = item || {};
  return item_location_replacementType_s === "REPLACEMENT" ? item_location_replacedItem_s : null;
};
const getReviewRatingData = (item, translationsObj) => {
  const {
    item_product_review_eligible,
    item_review_ratings,
    item_product_review_count
  } = item || {};
  const { translations } = translationsObj || {};
  if (Boolean(item_product_review_eligible) && typeof item_review_ratings === "string") {
    const parsedRating = parseFloat(item_review_ratings).toFixed(2);
    const mapObj = {
      "{rating}": parsedRating,
      "{total}": `${item_product_review_count}`
    };
    const ariaLabelText = translations == null ? void 0 : translations.averageratingarialabel.replace(
      /{rating}|{total}/gi,
      (matched) => mapObj[matched]
    );
    return {
      ariaLabel: +parsedRating ? ariaLabelText : translations == null ? void 0 : translations.noreviewsarialabel,
      reviewCount: item_product_review_count,
      value: +parsedRating
    };
  }
  return null;
};
const getCompareProductButtonData = (item) => {
  const { item_product_comparable } = item || {};
  const isTwoDayDeliveryKeyExists = isProgramTypeExists(
    item,
    ProgramTypeVariants.TWO_DAY_DELIVERY
  );
  return !isTwoDayDeliveryKeyExists && Boolean(item_product_comparable);
};
const convertProgramTypesToLowercase = (programType) => {
  return new Set(programType == null ? void 0 : programType.map((pType) => pType.toLocaleLowerCase()));
};
const getPriceData = (item, cookieContext, opts) => {
  const {
    translationsConfig,
    inWarehouseChannelBadgeData,
    featureToggleConfig
  } = opts || {};
  const { wcMember } = cookieContext;
  if (!hasMembershipId(wcMember.value) && itemIsMemberOnlyPriceInCartOnly(item))
    return null;
  const {
    item_program_eligibility,
    minSalePrice,
    maxSalePrice,
    item_product_price_in_cart_only,
    hasSingleSku,
    Hide_Price_Range_attr,
    adButlerPriceText
  } = item || {};
  if (adButlerPriceText) {
    return {
      adButlerPriceText
    };
  }
  const toLowerCaseProgramTypeSet = convertProgramTypesToLowercase(
    item_program_eligibility
  );
  const programTypeCheck = isBD() ? true : PROGRAM_TYPES_PRICE.some(
    (type) => toLowerCaseProgramTypeSet.has(type.toLocaleLowerCase())
  );
  const { warehousePriceOnline } = featureToggleConfig || {};
  if (programTypeCheck && item_product_price_in_cart_only !== "2" && minSalePrice) {
    const fulfillmentTexts = translationsConfig && (warehousePriceOnline == null ? void 0 : warehousePriceOnline.isEnabled) ? getProductFullfillmentTexts(
      ProductFulfillmentCategories.ONLINE,
      translationsConfig
    ) : null;
    const priceData = {
      priceText: null,
      priceValue: minSalePrice,
      fulfillmentTexts
    };
    if (!hasSingleSku) {
      if (Hide_Price_Range_attr === "1" && maxSalePrice && minSalePrice < maxSalePrice) {
        priceData.priceText = "Starting at";
        return priceData;
      } else if (minSalePrice === maxSalePrice) {
        return priceData;
      } else if (minSalePrice != null && maxSalePrice != null) {
        priceData.priceValue = [minSalePrice, maxSalePrice];
        return priceData;
      }
    } else {
      return priceData;
    }
  } else if (!!inWarehouseChannelBadgeData && (warehousePriceOnline == null ? void 0 : warehousePriceOnline.isEnabled)) {
    const programTypeCheckWarehouse = isBC() && PROGRAM_TYPES_PRICE_WAREHOUSE.some(
      (type) => toLowerCaseProgramTypeSet.has(type.toLocaleLowerCase())
    );
    const { item_warehouse_onlinePrice } = item || {};
    if (!programTypeCheckWarehouse || !hasSingleSku || !item_warehouse_onlinePrice)
      return null;
    const fulfillmentTexts = translationsConfig ? getProductFullfillmentTexts(
      ProductFulfillmentCategories.WAREHOUSE,
      translationsConfig
    ) : null;
    return {
      priceText: null,
      priceValue: item_warehouse_onlinePrice,
      fulfillmentTexts
    };
  }
  return null;
};
const getAddToListButtonData = (item, cookieContent) => {
  const {
    hasSingleSku,
    item_collateral_primaryimage,
    item_product_name,
    item_location_availability,
    item_disponzeroinv,
    item_backorderflag,
    item_backorderqty,
    item_product_buyable,
    item_buyable,
    content_type,
    Bundle_attr,
    item_classification_itemclass
  } = item || {};
  const price = getPriceData(item, cookieContent);
  const inStock = item_location_availability === "in stock" || item_disponzeroinv && item_backorderflag && item_backorderqty;
  const isPurchasable = item_product_buyable && item_buyable;
  const hideListButton = Boolean(
    item_classification_itemclass && PRODUCT_CLASS_TYPES.includes(item_classification_itemclass)
  );
  const inStockPurchaseable = isBD() ? isPurchasable : inStock && isPurchasable || !inStock && !isPurchasable;
  if (hasSingleSku && // single sku
  inStockPurchaseable && !hideListButton && // not hide list button
  !(content_type == null ? void 0 : content_type.includes(TRAVEL_DESTINATION)) && // content type not including travel destination
  !Bundle_attr) {
    return {
      image: item_collateral_primaryimage,
      name: item_product_name,
      price: (price == null ? void 0 : price.priceValue) || null
    };
  }
  return null;
};
const getInWarehouseAvailabilityText = (item) => {
  return isProgramTypeExists(item, ProgramTypeVariants.TWO_DAY_DELIVERY);
};
const getProductDeliveryBadgeData = (item, translationsConfig, baseUrl) => {
  const { urls } = translationsConfig || {};
  const checkTwoDayDeliveryExists = isProgramTypeExists(
    item,
    ProgramTypeVariants.TWO_DAY_DELIVERY
  );
  const checkCostcoGroceryExists = isProgramTypeExists(
    item,
    ProgramTypeVariants.COSTCOGROCERY
  );
  if (checkTwoDayDeliveryExists || checkCostcoGroceryExists) {
    return {
      linkUrl: `${baseUrl}${(urls == null ? void 0 : urls.groceryURL) || ""}`
    };
  }
  return null;
};
const hasInWarehouseStock = (item) => {
  const { inWarehouseStatus } = item || {};
  return inWarehouseStatus === "in stock" || inWarehouseStatus === "low stock";
};
const hasDeliveryViaInstacart = (item) => {
  return isProgramTypeExists(item, ProgramTypeVariants.THIRD_PARTY_DELIVERY) && hasInWarehouseStock(item);
};
const getDeliveryStatus = (item, cookieContext, featureToggleConfig) => {
  const { userLocation } = cookieContext;
  const { city } = userLocation;
  const { deliveryStatus, item_product_buyable, isFutureDate } = item || {};
  const { warehousePriceOnline } = featureToggleConfig || {};
  const isDeliveryViaInstacart = (warehousePriceOnline == null ? void 0 : warehousePriceOnline.isEnabled) && hasDeliveryViaInstacart(item);
  if (!city || !deliveryStatus) {
    if (isDeliveryViaInstacart && city) return DeliveryStatus.ViaInstacart;
    return null;
  }
  if (item_product_buyable && isFutureDate) return DeliveryStatus.ComingSoon;
  if (item_product_buyable && !isFutureDate) {
    if (deliveryStatus === "in stock" || deliveryStatus === "low stock") {
      return DeliveryStatus.Available;
    } else if (deliveryStatus === "out of stock") {
      return DeliveryStatus.OutOfStock;
    } else {
      return DeliveryStatus.Unavailable;
    }
  }
  if (isDeliveryViaInstacart) return DeliveryStatus.ViaInstacart;
  return null;
};
const getDeliveryChannelBadgeData = (item, cookieContext, featureToggleConfig) => {
  const deliveryStatus = getDeliveryStatus(
    item,
    cookieContext,
    featureToggleConfig
  );
  if (deliveryStatus === DeliveryStatus.ViaInstacart) {
    return {
      status: DeliveryStatus.ViaInstacart,
      showPriceMayVaryText: true
    };
  }
  if (!deliveryStatus) return null;
  return {
    status: deliveryStatus
  };
};
const getColorSwatchesData = (item, imageConfig, featureToggleConfig) => {
  const {
    item_product_image_swatchable,
    images,
    item_product_name,
    group_id
  } = item || {};
  if (!item_product_image_swatchable) return null;
  const colorSwatchesData = [];
  images == null ? void 0 : images.forEach((swatchItem) => {
    var _a;
    const {
      item_swatch_attribute,
      item_swatch_image,
      item_swatch_value,
      item_collateral_primaryimage
    } = swatchItem;
    colorSwatchesData == null ? void 0 : colorSwatchesData.push({
      attributeValue: item_swatch_value || "",
      id: item_swatch_value || "",
      label: item_swatch_attribute || "",
      pdpNavigationUrl: getProductNavigationUrl(
        item_product_name || "",
        group_id || "",
        imageConfig.domainUrl,
        item_swatch_value,
        item_swatch_attribute,
        (_a = featureToggleConfig == null ? void 0 : featureToggleConfig.enableBModPDPNavigationUrl) == null ? void 0 : _a.isEnabled
      ),
      productImageUrl: item_collateral_primaryimage || "",
      swatchImageUrl: item_swatch_image || ""
    });
  });
  return (colorSwatchesData == null ? void 0 : colorSwatchesData.length) ? colorSwatchesData : null;
};
const getInWareHouseChannelBadgeData = (item, enabledWarehousesListConfig, featureToggleConfig, cookieContext, showMultiVariantsAvailability) => {
  var _a, _b, _c;
  const { warehouse, userLocation } = cookieContext;
  const { nearestWarehouse } = warehouse;
  const { city } = userLocation;
  const { bopiwUpdatesSync, warehousePriceOnline } = featureToggleConfig || {};
  const isEnableBOPIWUpdatesSync = Boolean(bopiwUpdatesSync == null ? void 0 : bopiwUpdatesSync.featureOn);
  const isWarehouseEnabled = (_a = enabledWarehousesListConfig == null ? void 0 : enabledWarehousesListConfig.enabledWarehousesList) == null ? void 0 : _a.some(
    (enabledWarehouseId) => enabledWarehouseId === (nearestWarehouse == null ? void 0 : nearestWarehouse.catalog)
  );
  const lwxBOPIWWarehouseEnabled = (_b = enabledWarehousesListConfig == null ? void 0 : enabledWarehousesListConfig.enabledWarehousesBOPIWList) == null ? void 0 : _b.some(
    (enabledWarehouseId) => enabledWarehouseId === (nearestWarehouse == null ? void 0 : nearestWarehouse.catalog)
  );
  const lwxWIOWarehouseEnabled = (_c = enabledWarehousesListConfig == null ? void 0 : enabledWarehousesListConfig.enabledWarehousesWIOList) == null ? void 0 : _c.some(
    (enabledWarehouseId) => enabledWarehouseId === (nearestWarehouse == null ? void 0 : nearestWarehouse.catalog)
  );
  const {
    item_location_locationNumber,
    content_type,
    IsaVariant_attr,
    inWarehouseStatus,
    item_product_image_swatchable,
    hasSingleSku,
    item_location_bopiw,
    item_program_eligibility,
    deliveryStatus,
    Delivery_Type_attr
  } = item || {};
  const invalidLocationsCheck = INVALID_LOCATIONS.includes(
    item_location_locationNumber || ""
  );
  if (!isWarehouseEnabled || !city || invalidLocationsCheck || (content_type == null ? void 0 : content_type.includes(TRAVEL_DESTINATION)) || IsaVariant_attr && IsaVariant_attr.length > 0) {
    return null;
  }
  const shipToWarehouseEnabled = (Delivery_Type_attr == null ? void 0 : Delivery_Type_attr.includes("Warehouse Pick-up")) || (Delivery_Type_attr == null ? void 0 : Delivery_Type_attr.includes("Cueillette à l’entrepôt"));
  const bopiwProgramType = item_program_eligibility == null ? void 0 : item_program_eligibility.includes(
    "UseWarehouseInventory"
  );
  const itemProgramType = !!inWarehouseStatus;
  if (isWarehouseEnabled && isEnableBOPIWUpdatesSync) {
    if (showMultiVariantsAvailability && (itemProgramType && item_product_image_swatchable || !hasSingleSku)) {
      if (bopiwProgramType) {
        return {
          status: WarehouseChannelBadgeStatus.SEE_PRODUCT_DETAILS,
          warehouse: city
        };
      } else {
        return null;
      }
    }
    if (item_location_bopiw || itemProgramType && inWarehouseStatus === "in stock" || inWarehouseStatus === "low stock") {
      if (item_location_bopiw && bopiwProgramType && inWarehouseStatus === "in stock") {
        return {
          status: WarehouseChannelBadgeStatus.IN_STOCK_PICK_UP,
          warehouse: city
        };
      }
      if (item_location_bopiw && bopiwProgramType && inWarehouseStatus === "low stock") {
        return {
          status: WarehouseChannelBadgeStatus.LOW_STOCK_IN_WAREHOUSE,
          warehouse: city
        };
      }
      if (item_location_bopiw && (deliveryStatus === "in stock" || deliveryStatus === "low stock") && shipToWarehouseEnabled) {
        return {
          status: WarehouseChannelBadgeStatus.SHIPS_TO_WAREHOUSE,
          warehouse: city
        };
      }
      return null;
    }
    if (itemProgramType && inWarehouseStatus === "out of stock") {
      if (item_location_bopiw && shipToWarehouseEnabled) {
        if (deliveryStatus === "in stock" || deliveryStatus === "low stock") {
          return {
            status: WarehouseChannelBadgeStatus.SHIPS_TO_WAREHOUSE,
            warehouse: city
          };
        }
      } else if (bopiwProgramType) {
        return {
          status: WarehouseChannelBadgeStatus.OUT_OF_STOCK,
          warehouse: city
        };
      }
    }
    return null;
  }
  const showPriceMayVaryText = !(warehousePriceOnline == null ? void 0 : warehousePriceOnline.isEnabled);
  if (isWarehouseEnabled) {
    if (showMultiVariantsAvailability && (inWarehouseStatus && item_product_image_swatchable || !hasSingleSku)) {
      if (lwxBOPIWWarehouseEnabled && bopiwProgramType || inWarehouseStatus && lwxWIOWarehouseEnabled) {
        return {
          status: WarehouseChannelBadgeStatus.SEE_PRODUCT_DETAILS,
          warehouse: city,
          ...lwxWIOWarehouseEnabled && {
            showPriceMayVaryText
          }
        };
      } else {
        return null;
      }
    }
    if (bopiwProgramType && shipToWarehouseEnabled) {
      if (item_location_bopiw && inWarehouseStatus === "in stock" && lwxBOPIWWarehouseEnabled) {
        return {
          status: WarehouseChannelBadgeStatus.IN_STOCK_PICK_UP,
          warehouse: city
        };
      }
      if (!item_location_bopiw && (deliveryStatus === "in stock" || deliveryStatus === "low stock")) {
        return {
          status: WarehouseChannelBadgeStatus.SHIPS_TO_WAREHOUSE,
          warehouse: city
        };
      }
      return null;
    }
    if (bopiwProgramType) {
      if (item_location_bopiw && inWarehouseStatus === "in stock" && lwxBOPIWWarehouseEnabled) {
        return {
          status: WarehouseChannelBadgeStatus.IN_STOCK_PICK_UP,
          warehouse: city
        };
      }
      if (!item_location_bopiw && inWarehouseStatus === "low stock") {
        return {
          status: WarehouseChannelBadgeStatus.LOW_STOCK_IN_WAREHOUSE,
          warehouse: city,
          ...lwxWIOWarehouseEnabled && {
            showPriceMayVaryText
          }
        };
      }
      if (!item_location_bopiw && inWarehouseStatus === "in stock") {
        return {
          showPriceMayVaryText,
          status: WarehouseChannelBadgeStatus.IN_STOCK_IN_WAREHOUSE,
          warehouse: city
        };
      }
      if (!item_location_bopiw && inWarehouseStatus === "out of stock") {
        return {
          status: WarehouseChannelBadgeStatus.OUT_OF_STOCK,
          warehouse: city
        };
      }
      return null;
    }
    if (shipToWarehouseEnabled) {
      if (deliveryStatus === "in stock" || deliveryStatus === "low stock") {
        return {
          status: WarehouseChannelBadgeStatus.SHIPS_TO_WAREHOUSE,
          warehouse: city
        };
      }
      return null;
    }
    if (itemProgramType) {
      if (inWarehouseStatus === "in stock" && lwxWIOWarehouseEnabled) {
        return {
          showPriceMayVaryText,
          status: WarehouseChannelBadgeStatus.IN_STOCK_IN_WAREHOUSE,
          warehouse: city
        };
      }
      if (inWarehouseStatus === "low stock" && lwxWIOWarehouseEnabled) {
        return {
          status: WarehouseChannelBadgeStatus.LOW_STOCK_IN_WAREHOUSE,
          warehouse: city,
          ...lwxWIOWarehouseEnabled && {
            showPriceMayVaryText
          }
        };
      }
      if (inWarehouseStatus === "out of stock" && lwxWIOWarehouseEnabled) {
        return {
          status: WarehouseChannelBadgeStatus.OUT_OF_STOCK,
          warehouse: city
        };
      }
      return null;
    }
  }
  return null;
};
const getProductActions = (item, featureToggleConfig, translationsConfig, hasUserSignedId, cookieContext) => {
  var _a;
  const {
    item_member_only,
    item_product_buyable,
    item_buyable,
    isFutureDate,
    item_location_availability,
    item_disponzeroinv,
    item_backorderflag,
    item_backorderqty,
    hasSingleSku,
    deliveryStatus,
    item_product_price_in_cart_only,
    item_location_fulfillment_restrictions_maxQty,
    item_location_fulfillment_restrictions_minQty,
    group_id,
    item_number,
    Bundle_attr,
    item_classification_itemclass,
    item_as400_category,
    item_as400_department
  } = item || {};
  const { tobaccoInState } = translationsConfig;
  const { bdDeliveryLocation, wcMember } = cookieContext || {};
  const COMING_SOON_FEATURE_ENABLED = featureToggleConfig == null ? void 0 : featureToggleConfig.comingSoonBanner.featureOn;
  const PLP_STOCK_STATUS_DISPLAY_ENABLED = featureToggleConfig == null ? void 0 : featureToggleConfig.stockStatus.featureOn;
  const isPurchasable = Boolean(item_product_buyable && item_buyable);
  const enableAddButton = isPurchasable && Boolean(hasSingleSku);
  const isBundleAttr = Boolean(Bundle_attr && Bundle_attr.length > 0);
  const inStock = item_location_availability === "in stock" || item_disponzeroinv && item_backorderflag && item_backorderflag > 0 && item_backorderqty && item_backorderqty > 0;
  const comingSoon = Boolean(COMING_SOON_FEATURE_ENABLED && isFutureDate);
  const deliveryStatusCheck = !PLP_STOCK_STATUS_DISPLAY_ENABLED || deliveryStatus === "in stock" || deliveryStatus === "low stock";
  const hasDeliveryLocationZip = Boolean(bdDeliveryLocation == null ? void 0 : bdDeliveryLocation.zipCode);
  const bdMemberUnknown = !hasUserSignedId || !hasMembershipId((wcMember == null ? void 0 : wcMember.value) || "");
  const userOrLocationUnknown = !hasDeliveryLocationZip || bdMemberUnknown;
  const itemMemberOnly = Boolean(item_member_only);
  const itemShowsPriceInCartOnly = item_product_price_in_cart_only === "1";
  const itemIsTobacco = item_classification_itemclass === "Tobacco" || item_as400_category === "EBB" && item_as400_department === "11" && ((_a = bdDeliveryLocation == null ? void 0 : bdDeliveryLocation.bdLocation) == null ? void 0 : _a.includes(
    tobaccoInState == null ? void 0 : tobaccoInState.split("|")[1]
  ));
  const showAddToCartRegardlessOfUserAuth = hasDeliveryLocationZip && itemMemberOnly && !itemShowsPriceInCartOnly;
  const displayBDAddToCart = isBD() && isPurchasable && inStock && (showAddToCartRegardlessOfUserAuth || hasUserSignedId || hasMembershipId((wcMember == null ? void 0 : wcMember.value) || ""));
  const displayBDSignIn = isBD() && inStock && itemIsMemberOnlyPriceInCartOnly(item) && userOrLocationUnknown;
  const displayBDSignInForTobacco = (
    // is BD AND
    isBD() && // Buyable AND
    isPurchasable && // single sku AND
    hasSingleSku && // user unknown
    bdMemberUnknown && // some tobacco classification
    itemIsTobacco
  );
  if (itemIsMemberOnlyPriceInCartOnly(item) && !hasUserSignedId || displayBDSignIn || displayBDSignInForTobacco) {
    return { type: "SignInButton" };
  } else if ((!itemShowsPriceInCartOnly || !bdMemberUnknown && itemIsMemberOnlyPriceInCartOnly(item) || hasUserSignedId && !itemIsMemberOnlyPriceInCartOnly(item)) && enableAddButton && inStock && !comingSoon && deliveryStatusCheck && !isBundleAttr || displayBDAddToCart) {
    return {
      contractIdentifier: isProgramTypeExists(
        item,
        ProgramTypeVariants.TWO_DAY_DELIVERY
      ) ? "Regional" : void 0,
      itemNumber: item_number,
      maxQuantity: item_location_fulfillment_restrictions_maxQty,
      minQuantity: item_location_fulfillment_restrictions_minQty,
      partNumber: group_id,
      type: "QuantitySelector"
    };
  } else if (isBD() && !inStock && isPurchasable) {
    return { type: "OutOfStock" };
  } else if ((!inStock || !deliveryStatusCheck) && isPurchasable) {
    return { type: "SeeDetails" };
  } else if (isBD() && !isPurchasable) {
    return {};
  } else {
    return { type: "SelectOptions" };
  }
};
const isProgramTypeExists = (item, pType) => {
  const toLowerCaseProgramTypeSet = convertProgramTypesToLowercase(
    item == null ? void 0 : item.item_program_eligibility
  );
  return toLowerCaseProgramTypeSet.has(pType.toLowerCase());
};
const getDiscountsData = (pricingDiscountAmount) => {
  if (!pricingDiscountAmount) return null;
  return {
    displayDiscount: isBD(),
    totalDiscount: pricingDiscountAmount
  };
};
export {
  getAddToListButtonData,
  getColorSwatchesData,
  getCompareProductButtonData,
  getDeliveryChannelBadgeData,
  getDeliveryStatus,
  getDiscountsData,
  getInWareHouseChannelBadgeData,
  getInWarehouseAvailabilityText,
  getPillBadges,
  getPriceData,
  getProductActions,
  getProductDeliveryBadgeData,
  getReplacementItemNumber,
  getReviewRatingData,
  isProgramTypeExists,
  itemIsMemberOnlyPriceInCartOnly
};
